/** Formato della firma apposta sul documento. */
export enum SignatureFormat {
  CAdES = 'CADES',
  PAdES = 'PADES',
  Handwritten = 'AUTOGRAFA',
}

const SIGNATURE_FORMAT_VALUES = Object.values(SignatureFormat) as string[];

/**
 * Normalizza il valore (case-insensitive) ricevuto dal backend in un membro
 * di `SignatureFormat`. Ritorna `null` se il valore non è riconosciuto.
 */
export function parseSignatureFormat(
  value: string | null | undefined,
): SignatureFormat | null {
  if (!value) return null;

  const upper = value.toUpperCase();
  return SIGNATURE_FORMAT_VALUES.includes(upper)
    ? (upper as SignatureFormat)
    : null;
}
